import { useParams, useRouteContext } from '@tanstack/react-router';
import { z } from 'zod';
import { type RouteContextQuery, type RouteContextSelect, type RouteId } from '@/router/route-hooks.types';

const ROUTE_ID = '/_authenticated/_dashboard/accounts/$accountId/clusters/$clusterId' satisfies RouteId;

export const clusterIdUrlParam = z.guid().brand<'ClusterId'>();

/** Represents a unique identifier for a cluster coming from the URL param: clusterId */
export type ClusterId = z.infer<typeof clusterIdUrlParam>;

export const useClusterId = () => useParams({ from: ROUTE_ID, select: ({ clusterId }) => clusterId });

export const useRouteContextQuery = <TSelected extends RouteContextQuery>(
  select: RouteContextSelect<typeof ROUTE_ID, TSelected>,
) => useRouteContext({ from: ROUTE_ID, select });

/**
 * Returns the current cluster from the URL path params without throwing an error if not found.
 */
export const useSafeClusterId = () =>
  useParams({ from: ROUTE_ID, select: ({ clusterId }) => clusterId, shouldThrow: false });
